// OS PLANOS PELA RÉGUA DE 31/08 (LOTE 204, C1): o espelho na tela da fonte única do servidor (`creditos.PLANOS`).
// Cada R$ 1 vale 100 créditos, em qualquer plano.
import { formatarCreditos, formatarMoeda } from '@/lib/formatarNumero';

export const PLANOS = {
  cove: { nome: 'Cove', preco: 97, creditos: 9700 },
  harbor: { nome: 'Harbor', preco: 597, creditos: 59700 },
  voyage: { nome: 'Voyage', preco: 1497, creditos: 149700 },
  agencia: { nome: 'Agência', preco: 1797, creditos: 179700 },
  admiral: { nome: 'Admiral', preco: 3497, creditos: 349700 },
};

export const precoDoPlano = (chave) => `${formatarMoeda(PLANOS[chave].preco, { casas: 0 })}/mês`;
export const creditosDoPlano = (chave) => `${formatarCreditos(PLANOS[chave].creditos)}/mês`;
